import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=3bdcc69a&scoped=true&lang=pug&"
import script from "./Competition.vue?vue&type=script&lang=js&"
export * from "./Competition.vue?vue&type=script&lang=js&"
import style0 from "./Competition.vue?vue&type=style&index=0&id=3bdcc69a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcc69a",
  null
  
)

export default component.exports